/**
 * Минимальный store без внешних зависимостей.
 * При желании заменить на Zustand.
 */

import { useSyncExternalStore } from 'react';
import type { MeResponse } from '@memepad/shared';

interface State {
  me: MeResponse | null;
  authError: string | null;
}

let state: State = {
  me: null,
  authError: null,
};

const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

const actions = {
  setMe(me: MeResponse) {
    state = { ...state, me, authError: null };
    emit();
  },
  setAuthError(err: string | null) {
    state = { ...state, authError: err };
    emit();
  },
};

type Selector<T> = (s: State & typeof actions) => T;

export function useAppStore<T>(selector: Selector<T>): T {
  const sub = (cb: () => void) => {
    listeners.add(cb);
    return () => listeners.delete(cb);
  };
  const get = () => selector({ ...state, ...actions });
  return useSyncExternalStore(sub, get, get);
}
